import { useEffect } from 'react';

const useBackButton = (enabled: boolean, action: (event: Event) => void, deps: React.DependencyList = []) => {
  useEffect(() => {
    const onBack = (event: Event) => {
      event.stopImmediatePropagation();
      action(event);
    };

    if (enabled) {
      document.body.addEventListener('atvi_back_button', onBack);

      return () => {
        document.body.removeEventListener('atvi_back_button', onBack);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, ...deps]);
};

export default useBackButton;
